// ============================================
// 📁 routePaths.js - Routes centralisées
// ============================================

export const ROUTES = {
  // ----------------------------
  // 🔐 Authentification Patient
  // ----------------------------
  LANDING: "/",
  LOGIN: "/LoginPatient",
  SIGNUP_PATIENT: "/SignupPatient",
  VERIFY_CODE: "/VerifyCode",
  FORGOT_PASSWORD: "/ForgotPassword",
  SET_NEW_PASSWORD: "/SetNewPassword",

  // ----------------------------
  // 🧬 Dossier médical Patient
  // ----------------------------
  MEDICAL_RECORD: "/medicalrecord",
  RECORDS_TYPE: "/records/:type",
  MEDICAL_PROFILE: "/medicalprofile",
  OVERVIEWS: "/overviews",

  // ----------------------------
  // 👤 Profil utilisateur Patient
  // ----------------------------
  PROFILE: (userId = ":userId") => `/profile/${userId}`,
  
  // ✅ Sous-pages édition profil
  PROFILE_EDIT: "/profile/edit",
  PROFILE_EDIT_GENERAL: "/profile/edit/general",
  PROFILE_EDIT_HISTORY: "/profile/edit/history",
  PROFILE_EDIT_INSURANCE: "/profile/edit/insurance",

  // ----------------------------
  // 💬 Social, messagerie, RDV Patient
  // ----------------------------
  FEED: (userId = ":userId") => `/feed/${userId}`,
  MESSAGING: "/messaging",
  APPOINTMENTS: "/appointments",
  DOCTOR_DETAILS: (doctorId = ":doctorId") => `/doctor-details/${doctorId}`,
  DOCTORS: "/doctor-finder",

  // ----------------------------
  // 🏥 Lieux & services
  // ----------------------------
  PHARMACY: "/pharmacy",
  PHARMACIES: "/pharmacies",
  LAB: "/lab",
  CLINIQUE: "/clinique",
  KINE: "/kine",
  INFIRMARIES: "/infirmaries",

  // ----------------------------
  // 💊 Médicaments Patient
  // ----------------------------
  MEDICINES: "/medicines",
  ARCHIVE: "/medicines/archived",
  RELATIVES: "/relatives",

  // ----------------------------
  // 💳 Paiement & calendrier
  // ----------------------------
  CALENDAR: "/calendar",
  PAYMENT: "/payment",
  PAYMENT_SUCCESS: "/payment/success",
  PAYMENT_FAIL: "/payment/fail",

  // ----------------------------
  // 🧠 Analyse / Médecine
  // ----------------------------
  ANALYZER: "/analyzer",
  MedicalASSISTANT: "/MedicalAssistant",

  // ----------------------------
  // 🧰 Démos / UI
  // ----------------------------
  HEADER_DEMO: "/header",
  SIDE_DEMO: "/side",

  // ----------------------------
  // 🐾 Autres
  // ----------------------------
  PETS: "/pets",
  SETTINGS: "/settings",
  ABOUTCYCLE: "/aboutcycle",
  
  // ----------------------------
  // 🗑️ Wastebasket
  // ----------------------------
  WASTEBASKET: "/trash",

   FAMILY_TREE:"/family-tree",
};

// ============================================
// 👨‍⚕️ Routes Docteur
// ============================================
export const DOCTOR_ROUTES = {
  // ----------------------------
  // 🔐 Authentification Docteur
  // ----------------------------
  REGISTER_1: "/register1",
  REGISTER_2: "/register2",
  REGISTER_3: "/register3",
  REGISTER_4: "/register4",
  LOGIN: "/LoginDoctor",
  VERIFY_CODE: "/VerifCode",
  FORGOT_PASSWORD: "/ForgetPassword",
  EMAIL_CODE: "/EmailCode",

  // ----------------------------
  // 🏠 Pages principales Docteur
  // ----------------------------
  FEED: "/feeddoctor",
  PROFILE: "/doctorprofile",
  SETTINGS: "/settingsdoctor",
  APPOINTMENTS: "/AppointmentsDoctor",
  PATIENTS: "/patients",
  AVAILABILITY: "/availability",
  MESSAGES: "/messages",
  ASSISTANTS: "/assistants",


  // ----------------------------
  // 🏥 Services Docteur
  // ----------------------------
  PHARMACIES: "/pharmacies",
  CLINICS: "/clinics",
  LABS: "/analysis-lab",
  NURSES: "/nurses",
  MEDICAL_QUESTIONS: "/medical-questions-Doctor",

  // ----------------------------
  // 📋 Gestion patients (anciennes routes)
  // ----------------------------
  PATIENT_PROFILE: (id) => `/PatientProfile/${id}`,
  PATIENT_RECORD: (id) => `/PatientRecord/${id}`,
  FILE: "/doctorPages/consultation/:id",
  FILE_PAGE: (id = ":id") => `/doctorPages/consultation/${id}`,
  PRESCRIPTION: "/Perscription",

  // ----------------------------
  // 👥 Vue patient par le docteur (nouvelles routes - CORRIGÉ)
  // ✅ Ces routes sont RELATIVES à /doctor/patients/:patientId
  // ----------------------------
  OVERVIEWS_DECOR: "DoctorOverviewsPage",
  MEDICAL_RECORD_DECOR: "DoctorMedicalRecordPage",
  MEDICINES_DECOR: "DoctorMedicinesPage",
  RECORDS_TYPE_DECOR: "/doctor/patients/:patientId/records/:type",
  
  // ✅ Route complète pour la navigation
  DOCTOR_PATIENT_VIEW: (patientId) => `/doctor/patients/${patientId}`,
  PATIENT_PAYMENT_HISTORY: (patientId) =>
    `/doctor/patients/${patientId == null ? ":patientId" : encodeURIComponent(String(patientId))}/payment-history`,

  PROFILE_DOCTOR: (doctorId = ":doctorId") => `/doctor/${doctorId}/profile`,
  PROFILE_DR: (doctorId = ":doctorId") => `/drprofile/${doctorId}`,



};

export const ASSISTANT_ROUTES = {
  LOGIN: "/LoginAssistant",                       
  VERIFY_CODE: "/VerifyAssistantCode",            
  INVITATION_ACTIVATION: "/assistant/activate",   
  AVAILABILITY: "/assistant/availability",
  APPOINTMENTS: "/assistant/appointments",
  PATIENTS: "/assistant/patients",
  WAITING_ROOM: "/assistant/waiting-room",
  PAYMENT_HISTORY: (patientId) => `/assistant/payment-history/${patientId == null ? ":patientId" : encodeURIComponent(String(patientId))}`,
  PHARMACIES: "/assistant/pharmacies",
  CLINICS: "/assistant/clinics",
  ANALYSIS_LAB: "/assistant/analysis-lab",
  NURSES: "/assistant/nurses",
  PAYMENT: "/assistant/payment",
  CABINET_DASHBOARD: "/assistant/cabinet-dashboard",
};

export const ADMIN_ROUTES = {
  LOGIN: "/LoginAdmin",
  DASHBOARD: "/admin-dashboard"

}

export default ROUTES;